import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { Product } from '../../models/products-model/products.model';
import { ProductsService } from '../../services/products.service';
import { CdkAutofill } from '@angular/cdk/text-field';

@Component({
  selector: 'app-cart-card',
  imports: [MatIcon, NgClass, CommonModule, CdkAutofill],
  templateUrl: './cart-card.html',
  styleUrl: './cart-card.css',
})
export class CartCard {
  public mobile = false;
  private breakpointSubscription!: Subscription;
  @Input() product: Product | null = null;
  constructor(
    private breakpointObserver: BreakpointObserver,
    private productsService: ProductsService,
  ) {}

  ngOnInit(): void {
    this.checkScreenSize();
  }

  ngOnDestroy() {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }
  private checkScreenSize(): void {
    this.breakpointSubscription = this.breakpointObserver
      .observe(['(max-width: 1024px)'])
      .subscribe((result) => {
        this.mobile = result.matches;
      });
  }

  public addProduct() {
    this.product!.added = true;
    this.product!.amount = (this.product!.amount || 0) + 1;
    this.productsService.emitProduct.emit(this.product!);
  }

  public removeProduct() {
    this.product!.added = false;
    this.product!.amount = (this.product!.amount || 0) - 1;
    this.productsService.emitProduct.emit(this.product!);
  }
}
